
import type { RouteObject } from "react-router-dom";
import Layout from "../components/layout/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Courts from "../pages/courts/page";
import CourtDetail from "../pages/courts/detail/page";
import Sessions from "../pages/sessions/page";
import Learning from "../pages/learning/page";
import Scoreboard from "../pages/scoreboard/page";
import Login from "../pages/auth/login/page";
import Signup from "../pages/auth/signup/page";
import Profile from "../pages/profile/page";
import Admin from "../pages/admin/page";
import AdminLogin from "../pages/admin/login/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/courts",
        element: <Courts />,
      },
      {
        path: "/courts/:id",
        element: <CourtDetail />,
      },
      {
        path: "/sessions",
        element: <Sessions />,
      },
      {
        path: "/learning",
        element: <Learning />,
      },
      {
        path: "/scoreboard",
        element: <Scoreboard />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/admin",
        element: <Admin />,
      },
    ],
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
